import React, { Component } from 'react'
import { connect } from 'react-redux'
import DrawdownDetailsRow from './DrawdownDetailsRow'
import i18n from '../../../i18n'
import './PerformanceTable.css'
class DrawdownDetails extends Component {
  formatPercent(number, type) {
    if (type === 'drawdown') {
      return number !== null ? `${parseFloat(number * 100).toFixed(2)}%` : '-'
    }
    return number !== null ? `${parseFloat(number * 100).toFixed(2)}%` : '-'
  }

  formatDate(string) {
    let d = new Date(string).toLocaleDateString()
    return d
  }

  drawdownDetailsHeader(fund) {
    const { drawdownNumber } = this.props

    let drawdownDetails = fund.drawDownDetails
    let drawdownTopData = [...drawdownDetails]
    let dataToMap = []

    if (drawdownTopData.length > drawdownNumber) {
      dataToMap = drawdownTopData.slice(0, drawdownNumber)
    } else {
      dataToMap = drawdownTopData
    }

    let fundName = fund.name
    let fundTicker = fund.ticker
    let asOfDate = fund['drawDownDetails'][0].asOfDate
    const allStartDOrig = dataToMap.map(x => x.startDate)
    //const allEndDOrig = dataToMap.map(x => x.endDate)
    // let maxDate = new Date(
    //   Math.max(
    //     ...allEndDOrig.map(element => {
    //       return new Date(element)
    //     })
    //   )
    // )

    let minDate = new Date(
      Math.min(
        ...allStartDOrig.map(element => {
          return new Date(element)
        })
      )
    )

    // maxDate = new Date(maxDate.getTime() + maxDate.getTimezoneOffset() * 60000)
    minDate = new Date(minDate.getTime() + minDate.getTimezoneOffset() * 60000)

    let displayStartDate = this.formatDate(minDate)
    //  let displayEndDate = this.formatDate(maxDate)
    const [year, month, day] = asOfDate.split('-')
    let displayAsOf = `${month}/${day}/${year}`

    return (
      <thead>
        <tr key={fund.name}>
          <th colSpan='6' className='textLeft'>
            <span style={{ textTransform: 'uppercase' }}> {fundName + ' (' + fundTicker + ')'}</span> {displayStartDate} to {displayAsOf}{' '}
          </th>
        </tr>
        <tr>
          <th scope='col' className='textCenter'>
            {i18n.t('Drawdown')}
            <br /> {i18n.t('Start')}
          </th>
          <th scope='col' className='textCenter'>
            {i18n.t('Drawdown')}
            <br /> {i18n.t('End')}
          </th>
          <th scope='col' className='textCenter'>
            {i18n.t('Drawdown')}
            <br /> {i18n.t('Days')}
          </th>
          <th scope='col' className='textCenter'>
            {i18n.t('Drawdown')}
          </th>
          <th scope='col' className='textCenter'>
            {i18n.t('Recovered')}
            <br /> {i18n.t('by Date')}
          </th>
          <th scope='col' className='textCenter'>
            {i18n.t('Recovery')}
            <br /> {i18n.t('Days')}
          </th>
        </tr>
      </thead>
    )
  }


  drawdownDetailsRows(fund) {
    const { drawdownNumber } = this.props

    let drawdownDetails = fund.drawDownDetails
    let drawdownTopData = [...drawdownDetails]
    let dataToMap = []

    if (drawdownTopData.length > drawdownNumber) {
      dataToMap = drawdownTopData.slice(0, drawdownNumber)
    } else {
      dataToMap = drawdownTopData
    }

    if (dataToMap.length > 0) {
      return (
        dataToMap.map((value, index) => {
          return <DrawdownDetailsRow key={index} value={value} index={index} />
        })
      )
    } else {
      return null
    }
  }

  render() {
    const { data } = this.props

    let drawdownTopData = [...data]
    const drawDownData = drawdownTopData.filter(x => x.drawDownDetails !== null)
    const hasData = drawdownTopData.filter(e => e['drawDownDetails'])
    let asOfDate = hasData[0].drawDownDetails[0].asOfDate
    const [year, month, day] = asOfDate.split('-')
    let displayAsOf = `${month}/${day}/${year}`

    if (drawDownData.length > 0) {
      return drawDownData.map((fund) => {
        return (
          <div key={`div-${fund.externalID}`}>
            <div className='drawdownTitle'>
              <span style={{ textTransform: 'uppercase' }}>{i18n.t('TOP DRAWDOWNS ')}</span> {i18n.t('as of')} {displayAsOf}{' '}
            </div>
            <div className='table-responsive'>
              <table className='table tableFC'>               
                  {this.drawdownDetailsHeader(fund)}
                  <tbody>{this.drawdownDetailsRows(fund)}</tbody>
              </table>
            </div>
          </div>
        )
        
      })
    } else {
      return null
    }
  }
}

function mapStateToProps(state) {
  return {
    data: state.fundData.data,
    drawdownNumber: state.params.drawdownNumber
  }
}

export default connect(mapStateToProps, {})(DrawdownDetails)
